(() => {
  let frame = 0;
  const familyReviewProduct = 'custom-photo-pickleball-player-personalized-stained-glass-window-hanging-suncatcher';
  const familyReviews = [
    {
      author: 'Deborah H.',
      date: 'July 18, 2026',
      rating: 5,
      body: 'The suncatcher is beautiful.',
      image: 'https://review-images.judgeme.com/wahup/1784673064__0__5suwhSqd__1784664252__kfhuwqube7u__original__original.jpeg?quality=80&width=1024',
      product: 'Custom Photo Family Portrait Stained Glass Suncatcher Window Hanging',
      productUrl: '/products/custom-photo-family-portrait-stained-glass-suncatcher-window-hanging',
    },
    {
      author: 'Sylvia B.',
      date: 'July 16, 2026',
      rating: 5,
      body: 'I absolutely love it—it’s beautiful.',
      image: 'https://review-images.judgeme.com/wahup/1784673064__0__zTdKXx67__1784183815__1784183809680-img_7244__original__original.jpeg?quality=80&width=1024',
      product: 'Custom Photo Family Portrait Stained Glass Suncatcher Window Hanging',
      productUrl: '/products/custom-photo-family-portrait-stained-glass-suncatcher-window-hanging',
    },
    {
      author: 'Nancy Bacon',
      date: 'July 14, 2026',
      rating: 5,
      body: 'Came out great. It turned out better than I expected, and my friend was happy with the gift!',
      image: 'https://review-images.judgeme.com/wahup/1784046400__fgmiwuvdkji__original.avif?quality=80&width=1024',
      product: 'Personalized Photo Portrait Stained Glass Suncatcher Window Hanging – Family Gift',
      productUrl: '/products/personalized-photo-portrait-stained-glass-suncatcher-window-hanging-family-gift',
    },
  ];

  const currentProductHandle = () => {
    const match = window.location.pathname.match(/^\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const mountFamilyReviews = () => {
    if (currentProductHandle() !== familyReviewProduct || document.getElementById('wahup-family-reviews')) return;
    const judgeMeRoot = document.getElementById('judgeme_product_reviews');
    const officialWidget = judgeMeRoot && judgeMeRoot.querySelector('.jdgm-rev-widg');
    if (!judgeMeRoot || !officialWidget) return;

    const section = document.createElement('section');
    section.id = 'wahup-family-reviews';
    section.className = 'wahup-family-reviews';
    section.setAttribute('aria-labelledby', 'wahup-family-reviews-title');
    section.innerHTML = `
      <div class="wahup-family-reviews__header">
        <div>
          <p class="wahup-family-reviews__eyebrow">Real WAHUP customer photos</p>
          <h2 id="wahup-family-reviews-title">What customers say about our personalized stained-glass suncatchers</h2>
        </div>
        <div class="wahup-family-reviews__summary" aria-label="5 out of 5 stars from 3 related-product reviews">
          <strong>5.0</strong>
          <span class="wahup-family-reviews__stars" aria-hidden="true">★★★★★</span>
          <small>3 related-product reviews</small>
        </div>
      </div>
      <p class="wahup-family-reviews__disclosure">
        These reviews were written for related personalized stained-glass suncatchers. The original WAHUP product is identified on every review.
      </p>
      <div class="wahup-family-reviews__grid">
        ${familyReviews.map((review) => `
          <article class="wahup-family-review">
            <a class="wahup-family-review__photo" href="${review.productUrl}" aria-label="View ${review.product}">
              <img src="${review.image}" alt="Customer photo submitted with a review for ${review.product}" loading="lazy" width="640" height="640">
            </a>
            <div class="wahup-family-review__content">
              <div class="wahup-family-review__meta">
                <span class="wahup-family-review__stars" aria-label="${review.rating} out of 5 stars">${'★'.repeat(review.rating)}</span>
                <time>${review.date}</time>
              </div>
              <p class="wahup-family-review__body">${review.body}</p>
              <p class="wahup-family-review__author">${review.author}</p>
              <p class="wahup-family-review__product">Review for: <a href="${review.productUrl}">${review.product}</a></p>
            </div>
          </article>
        `).join('')}
      </div>
      <button class="wahup-family-reviews__write" type="button">Write a review for this pickleball design</button>
    `;

    const officialWriteButton = officialWidget.querySelector('.jdgm-write-rev-link');
    section.querySelector('.wahup-family-reviews__write').addEventListener('click', () => {
      if (officialWriteButton) officialWriteButton.click();
    });
    judgeMeRoot.parentNode.insertBefore(section, judgeMeRoot);

    const officialCount = Number(
      document.querySelector('.jdgm-prev-badge')?.dataset.numberOfReviews || 0
    );
    if (!officialCount) officialWidget.hidden = true;
  };

  const formatWidgets = () => {
    document.querySelectorAll('.jdgm-prev-badge').forEach((badge) => {
      const average = Number(badge.dataset.averageRating || 0);
      const count = Number(badge.dataset.numberOfReviews || 0);
      const text = badge.querySelector('.jdgm-prev-badge__text');
      if (average > 0 && count > 0 && text) {
        text.textContent = `${average.toFixed(1)} (${count})`;
        badge.style.display = 'flex';
      }
    });

    document.querySelectorAll('.jdgm-rev-widg__summary-average').forEach((average) => {
      const number = average.textContent.match(/\d+(?:\.\d+)?/);
      const target = average.querySelector('.jdgm-link') || average;
      if (number) target.textContent = number[0];
    });

    document.querySelectorAll('.jdgm-rev').forEach((review) => {
      const row = review.querySelector('.jdgm-row-product');
      if (!row || row.children.length || !review.dataset.productTitle) return;
      const wrapper = document.createElement('span');
      const link = document.createElement('a');
      wrapper.className = 'jdgm-rev__prod-info-wrapper';
      link.className = 'jdgm-rev__prod-link';
      link.textContent = review.dataset.productTitle;
      link.href = review.dataset.productUrl || '#';
      wrapper.append(link);
      row.append(wrapper);
    });

    mountFamilyReviews();
  };

  const scheduleFormat = () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(formatWidgets);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFormat, { once: true });
  } else {
    scheduleFormat();
  }

  new MutationObserver(scheduleFormat).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
